import { mutationTypes, produto } from '@/core/constants'
import FileManagerUtils from '@/core/utils/FileManagerUtils'
import Vue from 'vue'

export default {
	[mutationTypes.COMUM.SET_PRODUTO](state, data) {
		state.loki.product.id = data.id
		state.loki.product.name = data.nome
		state.loki.product.mainLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenu)
		state.loki.product.symbolLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenuRetraido)
		state.loki.product.logoMobile = FileManagerUtils.createUrl(data.atributosExtendidos.logoMobile)
		state.loki.product.version = produto.VERSAO
		state.loki.product.copywrite = produto.COPYRIGHT
	},

	[mutationTypes.COMUM.SET_RETRAIR_MENU](state) {
		Vue.set(state.loki, 'asideClosed', true)
	},

	[mutationTypes.COMUM.SET_USUARIO_LOGADO](state, usuario) {
		const user = {
			authorities: usuario.authorities,
			roles: usuario.roles,
			domainId: usuario.domainId,
			domainName: usuario.domainName,
			domainType: usuario.domainType,
			fullName: usuario.name,
			id: usuario.userId,
			name: usuario.userName,
			photo: FileManagerUtils.createThumbnailUrl(usuario.imageUrl),
			type: usuario.tipoUsuario,
		}
		Vue.set(state.loki, 'user', user)
		Vue.set(state, 'orgaoLogado', usuario.domainId)
	},

	[mutationTypes.COMUM.SET_MENU_AVATAR](state) {
		const actions = {
			1: { icon: 'mdi-account', path: '/perfil', title: 'Perfil' },
		}
		Vue.set(state.loki, 'avatarActions', actions)
	},

	[mutationTypes.COMUM.SET_EXPANDIR_MENU](state) {
		Vue.set(state.loki, 'asideClosed', false)
	},

	[mutationTypes.COMUM.SET_ROTA_ORIGEM](state, rota) {
		Vue.set(state.comum.rota, 'origem', rota)
	},

	[mutationTypes.COMUM.SET_LINK_ARQUIVO](state) {
		Vue.set(state.loki.file, 'api', produto.LINK_ARQUIVO)
	},

	[mutationTypes.COMUM.SET_PARAMETROS_SISTEMA](state, parametros) {
		Vue.set(state, 'parametrosSistema', parametros)
	},

	[mutationTypes.COMUM.SET_INFO_CABECALHO](state, informacoes) {
		state.cabecalhoPadrao = informacoes
	},
	[mutationTypes.COMUM.SET_KEY_CABECALHO](state) {
		state.cabecalhoKey++
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ARQUIVO_TEMPORARIO](state, arquivo) {
		state.campoArquivoNovo.arquivoTemporario = arquivo
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.LIMPAR_ARQUIVO_TEMPORARIO](state) {
		state.campoArquivoNovo.arquivoTemporario = null
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ERRO_OBRIGATORIEDADE_ARQUIVO](state, flag) {
		state.campoArquivoNovo.erroObrigatoriedade = flag
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_ARQUIVO_ENVIADO](state, flag) {
		state.campoArquivoNovo.validacaoDocuentoEnviado = flag
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_DOCUMENTO_SELECIONADO](state, documento) {
		state.campoArquivoNovo.documentoSelecionado = documento
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.LIMPAR_DOCUMENTO_SELECIONADO](state) {
		state.campoArquivoNovo.documentoSelecionado = null
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.SET_DOCUMENTO_COM_ANEXOS](state, documentoComAnexo) {
		state.campoArquivoNovo.documentoComAnexo = documentoComAnexo
	},
	[mutationTypes.COMUM.CAMPO_ARQUIVO_NOVO.LIMPAR_DOCUMENTO_COM_ANEXOS](state) {
		state.campoArquivoNovo.documentoComAnexo = null
	},
	[mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.SET_EXIBICAO](state, flag) {
		state.modalAssinaturaFlowbee.exibir = flag
	},
	[mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.SET_DOCUMENTOS](state, documentos) {
		state.modalAssinaturaFlowbee.documentosSelecionados = documentos
	},
	[mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.LIMPAR](state) {
		state.modalAssinaturaFlowbee.documentosSelecionados = []
	},
	[mutationTypes.COMUM.CAMPO_EDITAR_NUMERO.SET_NUMERO](state, numero) {
		state.campoEditarNumero.numero = numero
	},
	[mutationTypes.COMUM.INCREMENT_REQUESTS_IN_PROGRESS](state) {
		state.comum.requisicoesPendentes++
	},
	[mutationTypes.COMUM.DECREMENT_REQUESTS_IN_PROGRESS](state) {
		state.comum.requisicoesPendentes = Math.max(state.comum.requisicoesPendentes - 1, 0)
	},
	[mutationTypes.COMUM.SET_EXECUTAR_SEM_LOADING](state, flag) {
		state.comum.executarSemLoading = flag
	},
	[mutationTypes.COMUM.SET_LOADING_MANUAL](state, payload) {
		state.comum.loadingManual = payload
	},
	[mutationTypes.COMUM.SET_SALVAMENTO_AUTOMATICO_ERRO](state, salvamentoAutomaticoErro) {
		state.comum.isSalvamentoAutomaticoErro = salvamentoAutomaticoErro
	},
	[mutationTypes.COMUM.MOSTRAR_FALHA_SALVAMENTO_AUTOMATICO](state) {
		state.comum.isSalvamentoAutomaticoErro = true
		this.commit(mutationTypes.COMUM.SET_DESABILITAR_SALVAMENTO_AUTOMATICO)
		this.commit(mutationTypes.LOKI.SET_AUTO_SAVED_MESSAGE, 'Última atualização não salva')
		this.commit(mutationTypes.LOKI.SET_SAVING_MESSAGE, '${date} atrás')
	},
	[mutationTypes.COMUM.SET_HABILITAR_SALVAMENTO_AUTOMATICO](state) {
		state.comum.isSalvamentoAutomaticoErro = false
		state.comum.quantidadeRequisicoesSalvamentoAutomatico++
		this.commit(mutationTypes.LOKI.SET_AUTO_SAVED_MESSAGE, '<i class="fas fa-check mr-1"></i> Salvo Automaticamente')
		this.commit(mutationTypes.LOKI.SET_SAVING_MESSAGE, 'Salvo ${date} atrás')
		this.commit(mutationTypes.LOKI.ENABLE_AUTO_SAVING)
	},
	[mutationTypes.COMUM.SET_DESABILITAR_SALVAMENTO_AUTOMATICO](state) {
		state.comum.quantidadeRequisicoesSalvamentoAutomatico--
		if (state.comum.quantidadeRequisicoesSalvamentoAutomatico <= 0) {
			state.comum.quantidadeRequisicoesSalvamentoAutomatico = 0
			this.commit(mutationTypes.LOKI.DISABLE_AUTO_SAVING)
		}
	},
	[mutationTypes.ORGAO.EXIBIR_MODAL_ESCOLHA_ORGAO](state) {
		state.escolherOrgao.modal.exibir = true
	},
	[mutationTypes.ORGAO.FECHAR_MODAL_ESCOLHA_ORGAO](state) {
		state.escolherOrgao.modal.exibir = false
	},
}
